export default __webpack_public_path__ + "static/media/sliderContinuous_noThemeSelected.34fc1f43.svg";